import GetResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IDocumentType } from "../../documentTypes/model/DocumentType";
import DocumentTypeMapper from "../../documentTypes/service/DocumentTypeMapper";
import DocumentTypeParamMapper from "../../documentTypes/service/DocumentTypeParamMapper";
import Constants from "../common/Constants";

export default class GetCaseLawDocumentTypesForOrganisationInteractor {
  private resource: GetResourceEntriesInteractor<IDocumentType>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(organisationId: number) {
    return this.resource.execute(
      Constants.organisationCaseLawDocumentTypePath,
      DocumentTypeMapper,
      DocumentTypeParamMapper,
      {
        params: { organisationId }
      }
    );
  }
}
